export default "__VITE_ASSET__DpWS8AcZ__"